module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Slet onboarding steps")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    on: {
      "click": _vm.deleteSetupWidgetOpen
    }
  }, [_vm._v("Slet Setup widget åben?")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.deleteKlass
    }
  }, [_vm._v("Slet klasse")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("Slet Bruger")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.deleteRoom
    }
  }, [_vm._v("Slet Lokale")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.deleteMerge
    }
  }, [_vm._v("Slet Merge")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.deleteVacation
    }
  }, [_vm._v("Slet ferie")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.deleteScheduling
    }
  }, [_vm._v("Slet skemalægning")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ff80846!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/DeleteUserSettings.vue
// module id = 1685
// module chunks = 1